import { Box, Select, MenuItem, IconButton, Tooltip } from '@mui/material';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { getSelectMenuSx } from '../yourNotesNodeStyles';
import useYourNotesNode from './useYourNotesNode';
import topicGroupEngine from '../YourNotesGroupManager/TopicGroupEngine';

const PAGE_SIZE = 25;

const tooltipSx = {
    tooltip: { sx: { bgcolor: '#0b1e2e', color: '#b0c8e0', border: '0.5px solid #294766', fontSize: '11px', borderRadius: '3px' } },
    popper: { sx: { zIndex: 10000 } },
};

/**
 * YourNotesNodeHeader
 *
 * Dropdown to switch between nodes (e.g. High, Medium, Low).
 * Search icon opens TopicGroupSearchDialog scoped to the active group.
 * Uses useYourNotesNode hook for paint-triggered state — no direct engine calls.
 * @param {{ onSearchOpen: () => void }} props
 */
export default function YourNotesNodeHeader({ onSearchOpen }) {
    const { nodes, activeNode, selectNode } = useYourNotesNode();

    return (
        <Box className="yn-node-header">
            <Select
                value={activeNode ?? ''}
                onChange={(e) => selectNode(e.target.value)}
                size="small"
                className="yn-node-select"
                MenuProps={{ PaperProps: { sx: getSelectMenuSx() } }}
            >
                {(nodes ?? []).map((d) => {
                    const nPages = Math.ceil(d.total / PAGE_SIZE) || 1;
                    return (
                        <MenuItem key={d.key} value={d.key}>
                            {d.label} ({d.total}{nPages > 1 ? ` - ${nPages} pages` : ''})
                        </MenuItem>
                    );
                })}
            </Select>
            <Tooltip title="Search in group" componentsProps={tooltipSx}>
                <IconButton size="small" onClick={onSearchOpen} sx={{ color: '#6b8fa8', ml: '4px', '&:hover': { color: '#a3d1ff' } }}>
                    <ManageSearchIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
